import React from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import LazyImage from "components/atoms/LazyImage"

type EmptyStateProps = {
  message?: string;
  children?: React.ReactNode
}

export default function EmptyState(props: EmptyStateProps) {
  const { message = "", children } = props

  const { t } = useTranslation()

  return (
    <Stack width={"100%"} height={"100%"} flexGrow={1} justifyContent={"center"} alignItems={"center"}>
      <LazyImage
        src="/static/images/placeholder/empty-state.png"
        alt="empty state"
        style={{ width: "50%", height: "auto" }}
      />
      <Message>{message || t("general.emptyPage")}</Message>
      {children}
    </Stack>
  )
}

export const Message = styled(Typography)(({ theme }) => ({
  color: theme.palette.gray["14"],
  fontSize: "1.4rem",
  textAlign: "center",
  marginTop: "12px"
}))
